(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/react/components/freja/freja-main.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/react/components/freja/freja-main.js');

'use strict';

const {
  useEffect
} = React;
const {
  FrejaStart
} = svs.iam_idp.components.freja;
const {
  PollingMobile,
  PollingDesktop,
  Loading
} = svs.iam_idp.components.shared;
const {
  useAtomValue
} = jotai;
const {
  isPollingAtom,
  isNewCustomerAtom,
  loginCompletedAtom
} = svs.iam_idp.atoms;
const login = svs.iam_idp.utils.Login;
const FrejaMain = _ref => {
  let {
    showQR
  } = _ref;
  const isPolling = useAtomValue(isPollingAtom);
  const isNewCustomer = useAtomValue(isNewCustomerAtom);
  const loginCompleted = useAtomValue(loginCompletedAtom);
  const PollingComponent = showQR ? PollingDesktop : PollingMobile;
  useEffect(() => {
    if (showQR && !loginCompleted) {
      login.start(isNewCustomer);
    }
  }, [showQR, isNewCustomer, loginCompleted]);
  if (loginCompleted) {
    return React.createElement(Loading, null);
  }
  return isPolling && !showQR ? React.createElement(PollingComponent, null) : React.createElement(FrejaStart, {
    isNewCustomer: isNewCustomer,
    showQR: showQR
  });
};
svs.iam_idp.components.freja.FrejaMain = FrejaMain;

 })(window);